module.exports = __webpack_public_path__ + "static/media/penetration-testing.a270af89.png";